// https://vuex.vuejs.org/en/getters.html

export default {
    appVersion: state => state.packageVersion
}